class SaveChanges {
    constructor() {
        this.organizationID = new URLSearchParams(window.location.search).get('organizationID');
        this.dnsServersFormValidator = null;
        this.dnsServersFormValidation();
        this.threatBlockerCheckbox();
        this.domainBlockingCheckbox();
        this.dnsServersCheckbox();
        this.initSaveChanges();
        this.ajaxForms();
    }
    initSaveChanges(){
        const thisClass = this;
        let saveChangesBtn = document.getElementById('saveChangesBtn');
        if(saveChangesBtn){
            saveChangesBtn.addEventListener('click', function (event) {
                event.preventDefault();
                if (event.currentTarget.disabled === false) {
                    Swal.fire({
                        html: `<span class="text-center text-primary">Are you sure you want to save these settings?</span>`,
                        icon: "warning",
                        iconColor: "#FF5206",
                        buttonsStyling: false,
                        reverseButtons: true,
                        showCancelButton: true,
                        confirmButtonText: "Save changes",
                        cancelButtonText: "Cancel",
                        customClass: {
                            confirmButton: "btn btn-danger mt-0",
                            cancelButton: 'btn btn-light-primary mt-0',
                        },
                    }).then((result) => {
                        if (result.isConfirmed) {
                            let threatBlockerForm = $('#frm-threatBlockerForm-threatBlockerForm');
                            let domainBlockingForm = $('#frm-domainBlockingForm-domainBlockingForm');
                            let dnsServersForm = $('#frm-dnsServersForm-dnsServersForm');
                            if(dnsServersForm.length > 0) {
                                thisClass.dnsServersFormValidator.validate().then(function (status) {
                                    if (status === 'Valid') {
                                        new bootstrap.Modal(document.getElementById('loading-modal')).show();
                                        if(threatBlockerForm.length > 0){
                                            threatBlockerForm.submit();
                                        } else if(domainBlockingForm.length > 0){
                                            domainBlockingForm.submit();
                                        } else {
                                            dnsServersForm.submit();
                                        }
                                    } else {
                                        const triggerEl = document.querySelector('.network-management-tab-menu a[href="#dns_servers_tab"]');
                                        bootstrap.Tab.getInstance(triggerEl).show();
                                    }
                                });
                            } else {
                                new bootstrap.Modal(document.getElementById('loading-modal')).show();
                                if(threatBlockerForm.length > 0){
                                    threatBlockerForm.submit();
                                } else if(domainBlockingForm.length > 0){
                                    domainBlockingForm.submit();
                                } else {
                                    thisClass.saveChanges();
                                }
                            }
                        }
                    });
                }
            });
        }
    }
    ajaxForms(){
        const thisClass = this;
        $.nette.ext('saveChangesForms', {
            success: function (payload, status, jqXHR, settings) {
                let formID = settings.nette.form[0].attributes.id.value;
                if(formID === 'frm-threatBlockerForm-threatBlockerForm'){
                    let domainBlockingForm = $('#frm-domainBlockingForm-domainBlockingForm');
                    if(domainBlockingForm.length > 0) {
                        domainBlockingForm.submit();
                    } else {
                        let dnsServersForm = $('#frm-dnsServersForm-dnsServersForm');
                        if(dnsServersForm.length > 0) {
                            dnsServersForm.submit();
                        } else {
                            thisClass.saveChanges();
                        }
                    }
                } else if(formID === 'frm-domainBlockingForm-domainBlockingForm'){
                    let dnsServersForm = $('#frm-dnsServersForm-dnsServersForm');
                    if(dnsServersForm.length > 0) {
                        dnsServersForm.submit();
                    } else {
                        thisClass.saveChanges();
                    }
                } else if(formID === 'frm-dnsServersForm-dnsServersForm'){
                    thisClass.saveChanges();
                }
            }
        });
    }
    getCurrentTab(){
        const tabs = document.querySelectorAll('.network-management-tab-menu .nav-link');
        let activeTab = null;
        tabs.forEach(tab => {
            if (tab.classList.contains('active')) {
                activeTab = tab.getAttribute('href');
            }
        });
        return activeTab;
    }
    setTab(tab){
        let activeTab = document.querySelector('.network-management-tab-menu .nav-link[href="'+tab+'"]');
        if(activeTab){
            bootstrap.Tab.getOrCreateInstance(activeTab).show();
        }
    }
    saveChanges(){
        const thisClass = this;
        const currentTab = this.getCurrentTab();
        naja.makeRequest('GET', '?do=saveChanges', {
            'organizationID': this.organizationID
        }, {
            history: false // Prevent URL changes in browser history
        }).then((response) => {
            if(response){
                new LeavePageDialog(false);
                bootstrap.Modal.getInstance(document.getElementById('loading-modal')).hide()
                new CustomDomainBlockingDatatable();
                new CustomDomainNamesDatatable();
                new CustomZoneForwardingDatatable();
                new ExcludedDomainsDatatable();
                thisClass.dnsServersFormValidation();
                thisClass.threatBlockerCheckbox();
                thisClass.domainBlockingCheckbox();
                thisClass.dnsServersCheckbox();
                thisClass.initSaveChanges();
                thisClass.setTab(currentTab);
                $.nette.load();

                if(response['gateway_response']['status'] === "success"){
                    toastr.success(response['gateway_response']['message']);
                }else{
                    toastr.warning(response['gateway_response']['message']);
                }
            }
        });
    }
    threatBlockerCheckbox(){
        const thisClass = this;
        let threatBlockerForm = document.getElementById('frm-threatBlockerForm-threatBlockerForm');
        if(threatBlockerForm){
            let checkbox = threatBlockerForm.querySelector('input[name=threatBlockerEnabled]');
            checkbox.addEventListener('change', (event) => {
                thisClass.changeDnsServersDependsOnThreatBlocker('threatBlocker', event.currentTarget.checked);
                if (event.currentTarget.checked) {
                    threatBlockerForm.querySelector('#threatBlockerWarningText').classList.add('d-none');
                } else {
                    threatBlockerForm.querySelector('#threatBlockerWarningText').classList.remove('d-none');
                }
                // Set Save Changes button active
                let saveChangesBtn = document.getElementById('saveChangesBtn');
                if(saveChangesBtn){
                    saveChangesBtn.disabled = false;
                    let pulseBtn = document.getElementById('saveChangesPulse');
                    if(!pulseBtn){
                        let pulseBtn = document.createElement("span");
                        pulseBtn.classList.add('pulse-ring', 'top-0', 'start-0', 'w-100', 'h-100');
                        pulseBtn.id = 'saveChangesPulse';
                        saveChangesBtn.appendChild(pulseBtn);
                    }
                }
                new LeavePageDialog(true);
            });
        }
    }
    domainBlockingCheckbox(){
        let domainBlockingForm = document.getElementById('frm-domainBlockingForm-domainBlockingForm');
        if(domainBlockingForm){
            let checkbox = domainBlockingForm.querySelector('input[name=domainBlockingEnabled]');
            checkbox.addEventListener('change', (event) => {
                // Set Save Changes button active
                let saveChangesBtn = document.getElementById('saveChangesBtn');
                if(saveChangesBtn){
                    saveChangesBtn.disabled = false;
                    let pulseBtn = document.getElementById('saveChangesPulse');
                    if(!pulseBtn){
                        let pulseBtn = document.createElement("span");
                        pulseBtn.classList.add('pulse-ring', 'top-0', 'start-0', 'w-100', 'h-100');
                        pulseBtn.id = 'saveChangesPulse';
                        saveChangesBtn.appendChild(pulseBtn);
                    }
                }
                new LeavePageDialog(true);
            });
        }
    }
    changeDnsServersDependsOnThreatBlocker(type, value) {
        const threatBlockerForm = document.getElementById('frm-threatBlockerForm-threatBlockerForm');
        const dnsServersForm = document.getElementById('frm-dnsServersForm-dnsServersForm');
        const isDnsServersFormCheckbox = dnsServersForm.querySelector('input[name=dnsServersEnabled]');

        const threatBlockerInput = threatBlockerForm.querySelector('input[name=threatBlockerEnabled]');
        const threatBlockerValue = threatBlockerInput.checked;

        const dnsServersFormWarningText = dnsServersForm.querySelector('#dnsServersFormWarningText');
        const threatBlockerFormWarningText = threatBlockerForm.querySelector('#threatBlockerWarningText');

        if (type === 'threatBlocker') {
            /** Threat Blocker is ON */
            if (value) {
                /** If DNS Server Form has checkbox and is not checked - check it... it must have the same status as the threat blocker checkbox */
                if (isDnsServersFormCheckbox && !isDnsServersFormCheckbox.checked) {
                    isDnsServersFormCheckbox.checked = true;
                    dnsServersFormWarningText.classList.add('d-none');
                } else if (!isDnsServersFormCheckbox && dnsServersForm.querySelector('input[name=dns_servers\\[\\]]:checked').value !== 'ga-servers-on') {
                    /** If DNS Server Form has not checkbox and value is not GA Servers */
                    /** If value is Custom Servers - close Custom Servers IP subform */
                    if ( dnsServersForm.querySelector('input[name=dns_servers\\[\\]]:checked').value === 'custom-servers') {
                        dnsServersForm.querySelector('#dnsServersFormCustomServers').classList.add('d-none');
                    }
                    /** If value is not GA Servers - check GA Servers */
                    dnsServersForm.querySelector('input[name=dns_servers\\[\\]][value=ga-servers-on]').checked = true;
                    dnsServersFormWarningText.classList.add('d-none');
                }
            } else {
                /** Threat Blocker is OFF */
                /** If DNS Server Form has checkbox and is checked - uncheck it... it must have the same status as the threat blocker checkbox */
                if (isDnsServersFormCheckbox && isDnsServersFormCheckbox.checked) {
                    isDnsServersFormCheckbox.checked = false;
                    dnsServersFormWarningText.classList.remove('d-none');
                } else if (!isDnsServersFormCheckbox && dnsServersForm.querySelector('input[name=dns_servers\\[\\]]:checked').value === 'ga-servers-on') {
                    /** If DNS Server Form has not checkbox and value is GA Servers - check Public DNS Servers */
                    dnsServersForm.querySelector('input[name=dns_servers\\[\\]][value=custom-servers]').checked = true;
                    dnsServersForm.querySelector('#dnsServersFormCustomServers').classList.remove('d-none');
                    dnsServersFormWarningText.classList.remove('d-none');
                }
            }
        } else if (type === 'dnsServers') {
            /** If DNS Server Form has checkbox and value is not as Threat blocker - set same value */
            if (isDnsServersFormCheckbox && value !== threatBlockerValue) {
                threatBlockerInput.checked = value;
                threatBlockerFormWarningText.classList.toggle('d-none', value);
            } else if (value === 'ga-servers-on' && !threatBlockerValue) {
                /** If DNS Server Form has not checkbox and value is GA Servers and Threat Blocker is not checked - check Threat Blocker */
                threatBlockerInput.checked = true;
                threatBlockerFormWarningText.classList.add('d-none');
            } else if (value !== 'ga-servers-on' && threatBlockerValue) {
                /** If DNS Server Form has not checkbox and value is not GA Servers and Threat Blocker is checked - uncheck Threat Blocker */
                threatBlockerInput.checked = false;
                threatBlockerFormWarningText.classList.remove('d-none');
            }
        }
    }
    dnsServersCheckbox(){
        const thisClass = this;
        let dnsServersForm = document.getElementById('frm-dnsServersForm-dnsServersForm');
        if(dnsServersForm){
            let checkbox = dnsServersForm.querySelector('input[name=dnsServersEnabled]');
            if(checkbox){
                checkbox.addEventListener('change', (event) => {
                    thisClass.changeDnsServersDependsOnThreatBlocker('dnsServers', event.currentTarget.checked);
                    if (event.currentTarget.checked) {
                        dnsServersForm.querySelector('#dnsServersFormWarningText').classList.add('d-none');
                    } else {
                        dnsServersForm.querySelector('#dnsServersFormWarningText').classList.remove('d-none');
                    }
                    // Set Save Changes button active
                    let saveChangesBtn = document.getElementById('saveChangesBtn');
                    if(saveChangesBtn){
                        saveChangesBtn.disabled = false;
                        let pulseBtn = document.getElementById('saveChangesPulse');
                        if(!pulseBtn){
                            let pulseBtn = document.createElement("span");
                            pulseBtn.classList.add('pulse-ring', 'top-0', 'start-0', 'w-100', 'h-100');
                            pulseBtn.id = 'saveChangesPulse';
                            saveChangesBtn.appendChild(pulseBtn);
                        }
                    }
                    new LeavePageDialog(true);
                });
            }
        }
    }
    dnsServersFormValidation(){
        let form = document.getElementById('frm-dnsServersForm-dnsServersForm');
        if(form){
            if(form.querySelector('input[name=dnsServersEnabled]')){
                this.dnsServersFormValidator = FormValidation.formValidation(
                    form,
                    {
                        fields: {
                            'dnsServersEnabled': {
                                validators: {

                                },
                            },
                        },
                        plugins: {
                            trigger: new FormValidation.plugins.Trigger(),
                            autoFocus: new FormValidation.plugins.AutoFocus(),
                            submitButton: new FormValidation.plugins.SubmitButton(),
                        }
                    }
                );
            } else {
                this.changeDnsServersRadioButton(form);
                let excludePrimarySecondary = function (){
                    let type = $(form).find('input[name=dns_servers\\[\\]]:checked').val();
                    return type !== "custom-servers";
                }

                this.dnsServersFormValidator = FormValidation.formValidation(
                    form,
                    {
                        fields: {
                            'dns_servers[]': {
                                validators: {
                                    notEmpty: {
                                        message: 'This field is required'
                                    },
                                },
                            },
                            'primary': {
                                validators: {
                                    notEmpty: {
                                        message: 'This field is required'
                                    },
                                    ip: {
                                        ipv6: false,
                                        message: 'The value is not valid IP address',
                                    },
                                },
                            },
                            'secondary': {
                                validators: {
                                    ip: {
                                        ipv6: false,
                                        message: 'The value is not valid IP address',
                                    },
                                },
                            },
                        },
                        plugins: {
                            trigger: new FormValidation.plugins.Trigger(),
                            autoFocus: new FormValidation.plugins.AutoFocus(),
                            submitButton: new FormValidation.plugins.SubmitButton(),
                            // defaultSubmit: new FormValidation.plugins.DefaultSubmit(), // Uncomment this line to enable normal button submit after form validation
                            bootstrap: new FormValidation.plugins.Bootstrap5({
                                rowSelector: '.fv-row',
                                eleInvalidClass: '',
                                eleValidClass: ''
                            }),
                            excluded: new FormValidation.plugins.Excluded({
                                excluded: function(field, element, elements) {
                                    if(field === 'primary' || field === 'secondary'){
                                        return excludePrimarySecondary();
                                    }
                                    return false;
                                }
                            }),
                        }
                    }
                );
            }
        }
    }
    changeDnsServersRadioButton(form) {
        const thisClass = this;
        let radioButtons = form.querySelectorAll('input[name=dns_servers\\[\\]]');
        radioButtons.forEach(radioButton => {
            radioButton.addEventListener('change', (event) => {
                thisClass.changeDnsServersDependsOnThreatBlocker('dnsServers', event.currentTarget.value);
                if (event.currentTarget.value === 'custom-servers') {
                    form.querySelector('#dnsServersFormCustomServers').classList.remove('d-none');
                } else {
                    form.querySelector('#dnsServersFormCustomServers').classList.add('d-none');
                }

                if (event.currentTarget.value === 'ga-servers-on') {
                    form.querySelector('#dnsServersFormWarningText').classList.add('d-none');
                } else {
                    form.querySelector('#dnsServersFormWarningText').classList.remove('d-none');
                }
                // Set Save Changes button active
                let saveChangesBtn = document.getElementById('saveChangesBtn');
                if(saveChangesBtn){
                    saveChangesBtn.disabled = false;
                    let pulseBtn = document.getElementById('saveChangesPulse');
                    if(!pulseBtn){
                        let pulseBtn = document.createElement("span");
                        pulseBtn.classList.add('pulse-ring', 'top-0', 'start-0', 'w-100', 'h-100');
                        pulseBtn.id = 'saveChangesPulse';
                        saveChangesBtn.appendChild(pulseBtn);
                    }
                }
                new LeavePageDialog(true);
            })
        });
    }
}
window.SaveChanges = SaveChanges;